import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoStaff4attendancesGetRes } from "./abst/DtoStaff4attendancesGetRes";

export class DtoStaff4attendancesGetResImple extends DtoStaff4attendancesGetRes {
  public pager = new DtoApiPager();
}
